import { TitleCasePipe } from '@angular/common';

export const APP_CONSTANTS = {
  VERSION: require('../../package.json').version,
  NAME: new TitleCasePipe().transform(
    require('../../package.json').name.replace(/-/g, ' ')
  )
};
